<template>
  <div class="b-modal-footer flex middle-xs">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">

</script>

<style>
  .b-modal-footer {
    padding: 24px;
    gap: 24px;
  }

  .b-modal-footer > div {
    flex: 1;
  }
</style>
